<!-- 测评结果卡片 -->
<template>
  <div
    class="container resultPage"
    :style="{
      background: `url(${bgImageUrl})`,
      'background-repeat': 'no-repeat',
      'background-size': '100% 100%',
      paddingTop: platform == 'app' ? `${statusBarHeight}vw` : 0,
    }"
  >
    <div class="navigator" v-if="platform == 'app'">
      <div class="back_share">
        <img
          class="back_img"
          src="@/assets/images/result/back.png"
          @click="back()"
          @touchmove.stop.prevent
          alt
        />
      </div>
    </div>
    <div class="page_content">
      <img
        class="result_img"
        :src="resultData.cardImageUrlResult"
        alt=""
        @click="toBigImg"
      />
      <div class="result_type_box">
        <div class="result_type_top">
          <img
            class="result_icon"
            src="@/assets/images/result/right_icon.png"
            alt=""
          />
          <div class="result_type">{{ resultData.cardCategoryOne }}</div>
        </div>
        <div class="result_type_bottom">
          <div class="result_subtitle">{{ resultData.cardCategoryTwo }}</div>
          <img
            class="left_icon"
            src="@/assets/images/result/left_icon.png"
            alt=""
          />
        </div>
      </div>
      <div class="result_content">
        <div class="result_sentence">{{ resultData.cardOneSentence }}</div>
        <van-button type="default" class="btn_item" @click="toReport" :disabled="canToReport">
          查看详细测评报告
        </van-button>
        <div class="result_population">{{ resultData.cardPopulation }}</div>
        <div class="result_share">
          <div class="share_item" @click="shareHandle('WX')">
            <img
              class="share_item_img"
              src="@/assets/images/result/wx_icon.png"
              alt=""
            />
            <div class="share_item_text">微信</div>
          </div>
          <div
            class="share_item"
            @click="shareHandle('PYQ')"
            v-if="platform == 'app'"
          >
            <img
              class="share_item_img"
              src="@/assets/images/result/circle_icon.png"
              alt=""
            />
            <div class="share_item_text">朋友圈</div>
          </div>
          <div class="share_item" @click="saveImg()" v-if="platform == 'app'">
            <img
              class="share_item_img"
              src="@/assets/images/result/picture_icon.png"
              alt=""
            />
            <div class="share_item_text">保存卡片</div>
          </div>
        </div>
        <!-- <div
          class="result_share share_wx"
          v-if="platform == 'wx'"
          @click="shareHandle"
        >
          <van-button type="default" class="btn_item">
            去分享
          </van-button>
        </div> -->
        <div class="result_title_box">
          <div class="result_title_line"></div>
          <div class="result_title_text">{{ resultData.assessmentTitle }}</div>
          <div class="result_title_line"></div>
        </div>
        <div class="result_time">{{ resultData.generateTime }}</div>
      </div>
    </div>
    <van-popup v-model="showPop" @click="showPop = false">
      <div class="share_content">
        <div class="share_content_first">
          <div class="share_content_second">
            请您点击这里
            <img
              class="share_icon1"
              src="@/assets/images/result/share_icon1.png"
              alt=""
            />
            进行分享哦
          </div>
          <img
            class="share_icon2"
            src="@/assets/images/result/share_icon2.png"
            alt=""
          />
        </div>
      </div>
    </van-popup>
    <van-popup v-model="showImgPop" @click="showImgPop = false">
      <div class="big_img_content">
        <div class="result_type_box">
        <div class="result_type_top">
          <img
            class="result_icon"
            src="@/assets/images/result/right_icon.png"
            alt=""
          />
          <div class="result_type">{{ resultData.cardCategoryOne }}</div>
        </div>
        <div class="result_type_bottom">
          <div class="result_subtitle">{{ resultData.cardCategoryTwo }}</div>
          <img
            class="left_icon"
            src="@/assets/images/result/left_icon.png"
            alt=""
          />
        </div>
      </div>
        <img
          class="big_img"
          :src="resultData.cardImageUrlResult"
          mode="widthFix"
          @click="showImgPop = false"
        />
        
      </div>
    </van-popup>
  </div>
</template>
<script>
import { getResult } from "@/api/result";
import { setStore, getStore } from "@/utils/mUtils";
export default {
  data() {
    // 这里存放数据
    return {
      bgImageUrl: require("@/assets/images/result/result_bg.png"),
      id: "",
      type: "",
      title: "",
      resultData: {},
      showPop: false,
      showImgPop: false,
      canToReport:true
    };
  },
  methods: {
    toBigImg() {
      this.showImgPop = true;
    },
    shareHandle(action) {
      const path = encodeURIComponent("Main");
      const params = {
        pageIndex: 0,
      };
      const encodeParams = encodeURIComponent(JSON.stringify(params));
      const url = `${this.$ShareUrl}/share?platform=wx&linkId=usr1jvrml77haac0&path=${path}&params=${encodeParams}`;
      let data = {
        title: this.resultData.assessmentTitle,
        img: this.resultData.cardImageUrlResult,
        url,
        action,
      };
      console.log("share - bridge", data);
      if (this.platform == "app") {
        this.$bridge.call("share", data);
      } else if (this.platform == "wx") {
        // console.log("看看route", this.$route);
        // const { type, reportId } = this.$route.query;
        // return;
        // 方案1:跳转第二次,用于触发返回后接收postMessage,性能有问题
        // const url = encodeURIComponent(
        //   `/share?type=${type}&reportId=${reportId}&shareWx=1`
        // );
        // this.$wx.miniProgram.postMessage({
        //   data: {
        //     action: "shareWx",
        //   },
        // });
        // 方案2:跳转小程序页面,用于分享,不能分享朋友圈
        // const url = encodeURIComponent(this.resultData.cardImageUrlResult);
        // this.$wx.miniProgram.navigateTo({
        //   url: `/pages/share/index?url=${url}`,
        // });
        // 方案3:提示或引导用户点击右上角3个点
        this.showPop = true;
        // 方案4:分享页面使用小程序页面,不可解决点击按钮分享朋友圈
      }
    },
    saveImg() {
      if (this.resultData.cardImageUrlResult) {
        if (this.platform == "app") {
          console.log("调用saveImg,传入", this.resultData.cardShareUrl);
          this.$bridge.call("savePic", this.resultData.cardShareUrl);
        }
      } else {
        return Toast("分享卡片生成中...");
      }
      // this.downloadImg(this.resultData.cardImageUrlResult);
      // this.$wx.miniProgram.postMessage({
      //   data: JSON.stringify({
      //     action: "saveImg",
      //     imgUrl: this.resultData.cardImageUrlResult,
      //   }),
      // });
      // uni.postMessage({
      //   data: {
      //     action: "saveImg",
      //     imgUrl: this.resultData.cardImageUrlResult,
      //   },
      //   success: function(res) {
      //     console.log("postMessage success", res);
      //   },
      //   fail: function(err) {
      //     console.log("postMessage fail", err);
      //   },
      // });
    },
    downloadImg(link) {
      const xhr = new XMLHttpRequest();
      // link是图片的url地址
      xhr.open("GET", link);
      xhr.responseType = "blob";
      xhr.send();
      xhr.onload = function() {
        const fileBlob = xhr.response;
        // 获取到了图片的Blob数据
        console.log(fileBlob);
        const fileUrl = URL.createObjectURL(fileBlob);
        console.log(fileUrl);
        const ele = document.createElement("a");
        ele.setAttribute("href", fileUrl);
        ele.setAttribute("download", "");
        ele.click();
        ele.innerHTML = "下载";
        document.body.appendChild(ele);
      };
    },

    toReport() {
      this.$router.push({
        path: "/report",
        query: {
          id: this.id || this.resultData.assessmentId,
          type: this.type,
          reportId: this.reportId,
          title: this.title,
        },
      });
    },
    back() {
      this.bridgeClose();
    },
    async getResultData() {
      const res = await getResult({ id: this.reportId });
      this.resultData = res.data;
      this.resultData.generateTime = new Date(
        this.resultData.generateTime * 1
      ).format("yyyy-MM-dd hh:mm");
      this.canToReport = false;
    },
  },
  created() {},
  mounted() {
    this.id = this.$route.query.id;
    this.reportId = this.$route.query.reportId;
    this.type = this.$route.query.type;
    this.title = this.$route.query.title;
    if(this.$route.query.transheight){
      console.log(this.$route.query.transheight);
      setStore('transHeight',this.$route.query.transheight)
    }
    this.getResultData();
  },
};
</script>
<style lang="scss" scoped>
// @import "~@/styles/variable.scss";
.container {
  color: #333333;
  // height: 100vh;
  background-color: #f3f4f6;
}
.resultPage {
  display: flex;
  /* padding: 80px 24px 24px 24px; */
  ::v-deep {
    .van-popup {
      background: transparent;
    }
  }
  .big_img_content {
    position: relative;
    top: 0%;
    width: 100vw;
    height: 100vh;
    color: #ffffff;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .big_img {
      width: 600px;
      min-height: 800px;
      border-radius: 20px;
    }
    .result_type_box {
      /* position: absolute; */
      margin-bottom: 40px;
      width: fit-content;
      .result_type_top {
        position: relative;
        display: inline-block;
        padding: 20px 0px 0px 20px;
        .result_icon {
          width: 59px;
          height: 22px;
          position: absolute;
          top: 0;
          right: -24px;
        }
        .result_type {
          font-family: PingFang SC;
          font-weight: bold;
          font-size: 30px;
          color: #ffffff;
        }
      }
      .result_type_bottom {
        position: relative;
        padding: 0px 20px 20px 30px;
        .result_subtitle {
          font-family: Alimama ShuHeiTi;
          font-weight: bold;
          font-size: 51px;
          color: #ffffff;
        }
        .left_icon {
          width: 53px;
          height: 30px;
          position: absolute;
          left: 0px;
          bottom: 0;
        }
      }
    }
  }
  .share_content {
    position: relative;
    top: 0%;
    width: 100vw;
    height: 100vh;
    color: #ffffff;
    .share_content_first {
      display: flex;
      justify-content: flex-end;
      align-items: baseline;
      .share_content_second {
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 30px;
        color: #ffffff;
        line-height: 42px;
        text-align: center;
      }
      .share_icon1 {
        width: 56px;
        height: 28px;
        margin: 0 12px;
      }
      .share_icon2 {
        width: 112px;
        height: 159px;
        margin-left: 14px;
        margin-bottom: 20px;
        margin-right: 126px;
      }
    }
  }
  .navigator {
    width: 100vw;
    height: 85px;
    color: #292929;
    padding: 25px 30px;
    /* position: fixed; */
    top: 0px;
    left: 0;
    z-index: 9;
    text-align: center;
    .back_share {
      width: 100%;
      .back_img {
        width: 21px;
        height: 38px;
        float: left;
      }
    }
  }
  .page_content {
    flex: 1;
    text-align: center;
    padding: 0 42px;
    overflow-y: scroll;
    .result_img {
      width: 289px;
      height: auto;
      margin-top: 50px;
      border-radius: 20px;
    }
    .result_type_box {
      margin: 0 auto;
      margin-top: 150px;
      width: fit-content;
      .result_type_top {
        position: relative;
        display: inline-block;
        padding: 20px 0px 0px 20px;
        .result_icon {
          width: 59px;
          height: 22px;
          position: absolute;
          top: 0;
          right: -24px;
        }
        .result_type {
          font-family: PingFang SC;
          font-weight: bold;
          font-size: 30px;
          color: #ffffff;
        }
      }
      .result_type_bottom {
        position: relative;
        padding: 0px 20px 20px 30px;
        .result_subtitle {
          font-family: Alimama ShuHeiTi;
          font-weight: bold;
          font-size: 51px;
          color: #ffffff;
        }
        .left_icon {
          width: 53px;
          height: 30px;
          position: absolute;
          left: 0px;
          bottom: 0;
        }
      }
    }
    .result_content {
      text-align: center;
      .result_sentence {
        font-family: Source Han Sans CN;
        font-weight: 400;
        font-size: 26px;
        color: #666666;
        margin-top: 77px;
        white-space: pre-wrap; /* 新增：支持换行符并自动换行 */
      }
      .btn_item {
        width: 372px;
        height: 88px;
        background: linear-gradient(90deg, #79e695, #5ad8b7);
        border-radius: 44px;
        font-family: PingFang SC;
        font-weight: bold;
        font-size: 32px;
        color: #ffffff;
        text-align: center;
        line-height: 88px;
        margin-top: 53px;
        border: none;
      }
      .result_population {
        font-family: Source Han Sans CN;
        font-weight: 400;
        font-size: 22px;
        color: #999999;
        margin-top: 77px;
        white-space: pre-wrap; /* 新增：支持换行符并自动换行 */
      }
      .result_share {
        display: flex;
        justify-content: space-around;
        /* grid-column-gap: 70px;
        grid-template-columns: 100px 100px 100px; */
        margin-top: 30px;
        .share_item {
          width: 100px;
          text-align: center;
          .share_item_img {
            width: 90px;
            height: 90px;
            margin-bottom: 24px;
          }
          .share_item_text {
            font-family: Source Han Sans CN;
            font-weight: 400;
            font-size: 24px;
            color: #999999;
          }
        }
      }
      .share_wx {
        display: flex;
        justify-content: center;
        margin-top: 0;
      }
      .result_title_box {
        margin-top: 41px;
        display: flex;
        align-items: center;
        justify-content: center;
        .result_title_line {
          width: 65px;
          height: 2px;
          background: #989898;
        }
        .result_title_text {
          font-family: Source Han Sans CN;
          font-weight: 400;
          font-size: 26px;
          color: #222222;
          margin: 0 20px;
        }
      }
      .result_time {
        font-family: PingFang SC;
        font-weight: 400;
        font-size: 20px;
        color: #999999;
        margin: 20px 0;
      }
    }
  }
}
</style>
